import React from 'react';
import { OrdemDeServicoCompleta } from '../../types/ordemServico';
import { User, Calendar, Clock, MapPin, FileText } from 'lucide-react';
import { formatDateBR } from '../../utils/dateUtils';

interface OsInformacoesGeraisSectionProps {
  os: OrdemDeServicoCompleta;
}

export const OsInformacoesGeraisSection: React.FC<OsInformacoesGeraisSectionProps> = ({ os }) => {
  const clienteNome = os.pedido?.pessoa?.nome || os.cliente_nome || 'Cliente não informado';

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-bold uppercase tracking-wider text-slate-400 flex items-center gap-2">
        <FileText className="w-4 h-4 text-red-600" />
        Informações Gerais da O.S
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Número OS */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase">O.S #</span>
          <span className="text-base font-bold text-slate-900">#{os.id}</span>
        </div>

        {/* Cliente */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl md:col-span-2">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <User className="w-3.5 h-3.5" /> Cliente
          </span>
          <span className="text-sm font-bold text-slate-900">{clienteNome}</span>
        </div>

        {/* Data Atendimento */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <Calendar className="w-3.5 h-3.5" /> Data de Atendimento
          </span>
          <span className="text-sm font-bold text-slate-900">{formatDateBR(os.data_atendimento)}</span>
        </div>

        {/* Horários */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl md:col-span-2">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <Clock className="w-3.5 h-3.5" /> Horários
          </span>
          <div className="text-xs font-semibold text-slate-900 mt-1 flex flex-wrap gap-4">
            <span>Início: <strong className="text-slate-900">{os.horario_inicio || '--:--'}</strong></span>
            <span>Final: <strong className="text-slate-900">{os.horario_final || '--:--'}</strong></span>
            <span>Total: <strong className="text-red-600">{os.hora_total || '--:--'}</strong></span>
          </div>
        </div>
      </div>

      {/* Descrição */}
      <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
        <span className="text-xs text-slate-400 font-semibold block uppercase">Descrição do Serviço</span>
        <p className="text-sm text-slate-800 mt-1 whitespace-pre-wrap">{os.descricao || 'Nenhuma descrição informada.'}</p>
      </div>

      {/* Endereços */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1 text-emerald-700">
            <MapPin className="w-3.5 h-3.5 text-emerald-600" /> Endereço de Retirada
          </span>
          <p className="text-sm font-medium text-slate-900 mt-1">{os.retirada || 'Não informado'}</p>
        </div>

        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1 text-red-700">
            <MapPin className="w-3.5 h-3.5 text-red-600" /> Endereço de Entrega
          </span>
          <p className="text-sm font-medium text-slate-900 mt-1">{os.entrega || 'Não informado'}</p>
        </div>
      </div>
    </div>
  );
};
